import { useContext } from 'react';
import { FilterContext } from 'components/filter/filters-next/FilterContext';
import { FilterDeleteButton } from 'components/filter/filters-next/FilterDeleteButton';
import { useDeleteFilter } from 'components/filter/filters-next/useDeleteFilter';

const DeleteFilter = () => {
    const deleteFilter = useDeleteFilter();
    const { nodeId } = useContext(FilterContext);

    if (!nodeId) {
        return null;
    }

    return (
        <FilterDeleteButton
            onClick={e => {
                e.preventDefault();
                deleteFilter();
            }}
        />
    );
};

export { DeleteFilter };
